import { all } from "redux-saga/effects"
import handleGetLeaderboard from "./handleGetLeaderboard"

export default function* () {
    yield all([handleGetLeaderboard])
}
